import { createContext, useContext } from "react";
import { IDoor } from "helpers/door-collection";
import { RollupType } from "containers/folders/types/server-rollups";
import { IShopViewSettings } from "./manage-shop-view/types";
import { FeatureFlags } from "helpers/feature-flags";

export interface IProductCollectionContext {
    sectionToolbarContentRef: React.RefObject<HTMLDivElement>;
    hasDoors: boolean;
    doors: IDoor[];
    isRollupMode: boolean;
    rollupType?: RollupType;
    canShopBrand: boolean;
    brandEntities?: any;
    shopViewSettings?: IShopViewSettings;
    readonly flags?: FeatureFlags;
    onResetShopViewSettings?: () => void;
}

export const ProductCollectionContext = createContext<IProductCollectionContext>({
    sectionToolbarContentRef: undefined,
    hasDoors: false,
    doors: [],
    isRollupMode: false,
    canShopBrand: false,
    brandEntities: {},
    shopViewSettings: null,
    flags: null,
});
export const useProductCollectionContext = () => useContext(ProductCollectionContext);
